/**
 * Created by vladislav on 11.02.2020
 */

const Rumble = function () {
    cleverapps.EventEmitter.call(this);

    this.outcome = Rumble.OUTCOME_UNKNOWN;

    this.rounds = [];

    this.inited = false;
    this.initedSuccess = 0;
    this.init((data) => {
        if (data) {
            const savedData = cleverapps.dataLoader.load(DataLoader.TYPES.RUMBLE);
            if (savedData) {
                this.players = savedData.players;
                PseudoRandom.GET().state = savedData.random;
            } else {
                this.players = this.preparePlayers(data);
            }

            this.randomState = PseudoRandom.GET().state;

            if (savedData && savedData.rounds) {
                for (let i = 0; i < (savedData.rounds && savedData.rounds.length); i++) {
                    this.rounds.push(new Round(this, savedData.rounds[i].players, savedData.rounds[i].winners));
                }
            } else {
                const players = cleverapps.shuffleInPlace(Object.keys(this.players).filter((playerId) => playerId !== Rumble.PLAYER_ID));
                players.splice(PseudoRandom.GET().random(0, 3), 0, Rumble.PLAYER_ID);
                this.addRound(players);
            }
            savedData && cleverapps.dataLoader.remove(DataLoader.TYPES.RUMBLE);
            this.initedSuccess = 1;
        } else {
            this.initedSuccess = 0;
        }

        this.inited = true;
        this.trigger("initialize");
    });
};

Rumble.prototype = Object.create(cleverapps.EventEmitter.prototype);
Rumble.prototype.constructor = Rumble;

Rumble.prototype.addRound = function (players) {
    this.rounds.push(new Round(this, players));
};

Rumble.prototype.moveNextRound = function (outcome) {
    const round = this.getCurrentRound();

    round.calcWinners(outcome);

    if (!round.isWinner(Rumble.PLAYER_ID)) {
        this.lose();
    } else {
        if (round.isLast()) {
            this.win();
        }
        this.addRound(round.winners);
    }
};

Rumble.prototype.whenInitialize = function (callback) {
    if (this.inited) {
        callback(this.initedSuccess);
    } else {
        this.on("initialize", () => {
            callback(this.initedSuccess);
        });
    }
};

Rumble.prototype.init = function (callback) { 
    const loadAvatars = function (players) {
        cleverapps.UI.Avatar.preload(players, cleverapps.waitNoMore(2000, () => {
            callback(players);
        }));
    };

    if (cleverapps.bots.getAmount() >= Rumble.OPPONENTS) {
        loadAvatars(cleverapps.bots.listBots(Rumble.OPPONENTS));
    } else {
        const waitNoMore = cleverapps.waitNoMore(5000, () => {
            cleverapps.bots.off("updateBots");

            if (cleverapps.bots.getAmount() >= Rumble.OPPONENTS) {
                loadAvatars(cleverapps.bots.listBots(Rumble.OPPONENTS));
            } else {
                loadAvatars([]);
            }
        });

        cleverapps.bots.reload();

        cleverapps.bots.on("updateBots", waitNoMore, this);
    }
};

Rumble.prototype.isFirstRound = function () {
    return this.rounds.length <= 1;
};

Rumble.prototype.getCurrentRound = function () {
    return this.rounds[this.rounds.length - 1];
};

Rumble.prototype.getPrevRound = function () {
    return this.rounds[this.rounds.length - 2];
};

Rumble.prototype.preparePlayers = function (players) {
    if (!players.length) {
        players = cleverapps.bots.listBots(Rumble.OPPONENTS);
    }

    players.push({
        id: Rumble.PLAYER_ID,
        name: cleverapps.user.getPlayerInfo().name,
        avatar: cleverapps.user.getPlayerInfo().avatar
    });

    const res = {};
    players.forEach((player) => {
        res[player.id] = player;
    });

    return res;
};

Rumble.prototype.giveUp = function () {
    this.outcome = Rumble.OUTCOME_GAVEUP;
};

Rumble.prototype.win = function () {
    this.outcome = Rumble.OUTCOME_WIN;
    cleverapps.knockoutGame.onWin();
};

Rumble.prototype.lose = function () {
    this.outcome = Rumble.OUTCOME_LOSE;
    cleverapps.knockoutGame.onLose();
};

Rumble.prototype.getInfo = function () {
    return {
        players: this.players,
        random: this.randomState,
        rounds: this.rounds.map((round) => round.getInfo())
    };
};

Rumble.OUTCOME_LOSE = 0;
Rumble.OUTCOME_WIN = 1;
Rumble.OUTCOME_UNKNOWN = 3;

Rumble.OPPONENTS = 7;

Rumble.PLAYER_ID = "12345";